import _ from "lodash";
import type { Account } from "../auth/myProfilesWithData";
import { parseLastConcernIdsCsv } from "./getUserMetadata";

export interface ProfilesSortedAndPartitionedByRecentConcerns {
  sortedProfiles: Account[];
  recentProfiles: Account[];
  otherProfiles: Account[];
}

/** Sort by stored last-concern visit order (`UserMetadata.lastConcernIds`), then concern name; split into recent vs other (same rules as profile menu). */
export function sortAndPartitionProfilesByRecentConcerns(
  profiles: Account[] | null | undefined,
  lastConcernIdsCsv: string | null | undefined
): ProfilesSortedAndPartitionedByRecentConcerns {
  if (!profiles?.length) {
    return {
      sortedProfiles: [],
      recentProfiles: [],
      otherProfiles: [],
    };
  }

  const lastConcernIds = parseLastConcernIdsCsv(lastConcernIdsCsv);
  const recentIdSet = new Set(lastConcernIds);
  const sortedProfiles = _.orderBy(
    profiles,
    [
      (a) => {
        const i = lastConcernIds.indexOf(a.concernId);
        return i === -1 ? Number.MAX_SAFE_INTEGER : i;
      },
      (a) => a.concernName,
    ],
    ["asc", "asc"]
  );
  const recentProfiles = sortedProfiles.filter((a) =>
    recentIdSet.has(a.concernId)
  );
  const otherProfiles = sortedProfiles.filter(
    (a) => !recentIdSet.has(a.concernId)
  );

  return { sortedProfiles, recentProfiles, otherProfiles };
}
